import { ApiRequest } from '@/helpers';

export const chats = {
  namespaced: true,
  state: getInitialState(),
  actions: {
    async deleteChat({}, data) {
      const response = await ApiRequest({
        method: 'delete',
        url: `${import.meta.env.VITE_API_URL}/chats`,
        params: data,
      });
      return response.data;
    },
    async sendChatMessage({}, data) {
      const response = await ApiRequest({
        method: 'post',
        url: `${import.meta.env.VITE_API_URL}/chats/message`,
        data,
      });
      return response.data;
    },
  },
  mutations: {
    setChats(state, chats) {
      state.chats = chats;
    },
    setMessageLoading(state, loading) {
      state.messageLoading = loading;
    },
    setSelectedChat(state, chat) {
      state.selectedChat = chat;
    },
    resetState(state) {
      Object.assign(state, getInitialState());
    },
  },
  getters: {

  },
};

function getInitialState() {
  return {
    chats: [],
    messageLoading: false,
    selectedChat: null,
  };
}
